import Vue from 'vue'
import Component from 'vue-class-component'
import convoStore from '../../store/convo/convo-store'
import feedStore from '@/store/feed/feed-store';
import authStore from '@/store/auth/auth-store';

@Component({
  name: 'convo-search',
})
export default class ConvoSearch extends Vue {
  get convoSearchForm () { return convoStore.state.convoSearchForm }

  get userFeed () { return !feedStore.state.isCurrent }

  get user () { return feedStore.feedUser }

  get isAuthenticated () { return authStore.isAuthenticated }

  protected addSearchTag (): void {
    convoStore.dispatchAddSearchTag()
  }

  protected removeSearchTag(tag: string): void {
    convoStore.dispatchRemoveSearchTag(tag)
  }

  protected toggleCreatedByUser (): void {
    convoStore.dispatchToggleCreatedByUser()
  }

  protected toggleCreatedByFollowing (): void {
    convoStore.dispatchToggleCreatedByFollowing()
  }

  protected toggleCreatedByMe (): void {
    convoStore.dispatchToggleCreatedByMe()
  }

  protected toggleLikedByUser (): void {
    convoStore.dispatchToggleLikedByUser()
  }

  protected toggleLikedByFollowing (): void {
    convoStore.dispatchToggleLikedByFollowing()
  }

  protected toggleLikedByMe (): void {
    convoStore.dispatchToggleLikedByMe()
  }

  protected toggleFollowedByMe (): void {
    convoStore.dispatchToggleFollowedByMe()
  }
}
